const BlockCharpente = ({blockTitle, blockContent}) => {

    return(
        <>
            <div className="form-container">
  <div className="form-head">
    <p className="text-center">
      {blockTitle}
    </p>
  </div>
  <div className="be-form p-3 p-md-5">
    <form action="">
      <div className="text-center">
        <div className="row select-elements">
            {blockContent.map((item, index) => 
                <div className="col-6 col-md-3 mb-4">
                    <label className="w-100">
                    <input
                        type="radio"
                        name="materiau"
                        defaultValue="ferme-traditionnelle"
                        className="materiau-radio"
                    />
                    <div className="materiau-wrapper farm-typology-card">
                        <div className="charpente-img">
                        <img
                            src={item.imageUrl}
                            alt={item.title}
                            style={{ maxWidth: "100%" }}
                        />
                        </div>
                        <div className="white-rectangle px-1 px-md-4 py-1">
                        <p className="Card-title text-center">{item.title}</p>
                        {/* <p class="Card-sub-title" style="opacity: 1; z-index: 2;">Terrace extérieure</p> */}
                        </div>
                    </div>
                    </label>
                </div>
            )}
        </div>
      </div>
    </form>
  </div>
</div>

        </>
    )

}

export default BlockCharpente